import React from 'react';
import { useTranslation } from 'react-i18next';

/** What a connect popup shows if the browser would not let it close itself. */
const ConnectPopupDone = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-6 text-sm text-foreground">
      {t('philBot.connectedCloseWindow')}
    </main>
  );
};

export default ConnectPopupDone;
